<template>
    <div>
        <section class="mobile-filters secondary-background d-block shadow d-sm-none px-2">
            <ul class="nav">
                <li class="nav-item">
                    <a class="nav-link" href="#mobileFilterModal" data-bs-toggle="modal" data-bs-target="#mobileFilterModal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-filter" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                        <span class="text-uppercase fw-600">{{ $t('messages.Filter') }}</span>
                    </a>
                </li>
                <li class="ms-auto nav-item my-auto">
                    <select class="form-select" v-model="selected.sortby" @change="filterProducts()" style="width:180px;">
                            <option value="recommended">{{ $t('messages.Recommended') }}</option>
                            <option value="latest">{{ $t('messages.Latest') }}</option>
                            <option value="oldest">{{ $t('messages.Oldest') }}</option>
                        </select>
                    <!-- <a class="nav-link my-auto" href="#" data-bs-toggle="dropdown">
                        <span class="text-uppercase fw-600">Sort by</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-sort-down-alt" viewBox="0 0 16 16">
                        <path d="M3.5 3.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 12.293V3.5zm4 .5a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1h-1zm0 3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm0 3a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1h-5zM7 12.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5z"/>
                        </svg>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end shadow rounded-5 border-light">
                        <li><a class="dropdown-item small" v-bind:href="recommended" name="sortby" v-model="selected.sortby" @click="filterProducts()">Recommended</a></li>
                        <li><a class="dropdown-item small" v-bind:href="latest" name="sortby" v-model="selected.sortby" @click="filterProducts()">Latest</a></li>
                        <li><a class="dropdown-item small" v-bind:href="oldest" name="sortby" v-model="selected.sortby" @click="filterProducts()">Oldest</a></li>
                    </ul> -->
                </li>
            </ul>
            <div class="modal fade" id="mobileFilterModal" tabindex="-1" aria-labelledby="mobileFilterModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen-sm-down">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="mobileFilterModalLabel">{{ $t('messages.Filter') }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="widget mb-5">
                            <h5 class="widget-title fs-6">{{ $t('messages.categories') }}</h5>
                            <ul class="widget-list list-unstyled">
                                <li class="form-check" v-for="category in categories" :key="category.id">
                                    <input class="form-check-input" type="radio" :value="category.slug" :id="category.slug" v-model="selected.category" @click="filterProducts()">
                                    <label class="form-check-label" :for="category.slug">{{ category.name[lang] }}</label>
                                </li>
                            </ul>
                        </div>
                        <div class="widget">
                            <h5 class="widget-title fs-6">{{ $t('messages.price') }}</h5>
                            <ul class="widget-list list-unstyled">
                                <li class="form-check">
                                    <input class="form-check-input" type="radio" value="0-25" id="price0_25" v-model="selected.price"  @click="filterProducts()">
                                    <label class="form-check-label" for="price0_25">0 - 25&euro;</label>
                                </li>
                                <li class="form-check">
                                    <input class="form-check-input" type="radio" value="25-50" id="price25_50" v-model="selected.price"  @click="filterProducts()">
                                    <label class="form-check-label" for="price25_50">25 - 50&euro;</label>
                                </li>
                                <li class="form-check">
                                    <input class="form-check-input" type="radio" value="50-75" id="price50_75" v-model="selected.price"  @click="filterProducts()">
                                    <label class="form-check-label" for="price50_75">50 - 75&euro;</label>
                                </li>
                                <li class="form-check">
                                    <input class="form-check-input" type="radio" value="75-100" id="price75_100" v-model="selected.price"  @click="filterProducts()">
                                    <label class="form-check-label" for="price75_100">75 - 100&euro;</label>
                                </li>
                                <li class="form-check">
                                    <input class="form-check-input" type="radio" value="100" id="price100" v-model="selected.price"  @click="filterProducts()">
                                    <label class="form-check-label" for="price100">100&euro; +</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">{{ $t('messages.Show') }} {{ products_total }} {{ $t('messages.results') }}</button>
                    </div>
                </div>
            </div>
            </div>
        </section>
        <section class="py-lg-5 pt-lg-3" id="filterResults">
        <div class="row">
            <div class="col-12 col-md-3 col-lg-2 pt-lg-5 pe-lg-4 d-none d-md-block">
                <div class="widget mb-5">
                    <ul class="widget-list mah-widget-list list-unstyled">
                        <li class="form-check" v-for="category in categories" :key="category.id">
                            <input class="form-check-input" type="radio" :value="category.slug" :id="category.slug" v-model="selected.category" @click="filterProducts()">
                            <label class="form-check-label" :for="category.slug">{{ category.name[lang] }}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-9 col-lg-10 pt-5 ps-3">
                <div class="row row-cols-2 row-cols-lg-4 g-2 g-lg-3">
                    <div v-for="product in products" :key="product.id" class="col">
                        <div class="card shadow-sm product-card mah-product-card mb-4">
                            <img :src="cdn_url+'products/'+product.image+'?auto=format,enhance,compress&fit=crop&crop=faces&h=220&w=285'" class="card-img-top" alt="" />
                            <div class="card-body p-3 p-lg-4 pb-0 pb-lg-0">
                                <a :href="'/'+lang+'/t/'+product.type+'/'+product.id+'/'+product.slug" class="product-title stretched-link">{{ product.title[lang] }}</a>
                                
                                <div class="card-text">
                                    <span class="text-muted">{{ $t('messages.startingfrom') }}</span>
                                </div>
                            </div>
                            <div class="card-bottom d-md-flex justify-content-between px-3 pb-3 px-lg-4 pb-lg-4">
                                <div class="product-price">
                                    <span class="fw-bold fs-5">{{ product.price }} &euro;</span>
                                </div>

                                <review-ratings :rating="product.rating_average"></review-ratings>
                            </div>
                        </div>
                    </div>
                    <infinite-loading :identifier="infiniteId" @infinite="loadProducts">
                        <div slot="spinner">
                            {{ $t('messages.loading') }}...
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:transparent;display:block;" width="5rem" height="5rem" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="50" cy="50" r="30" stroke="#303297" stroke-width="10" fill="none"></circle>
                                <circle cx="50" cy="50" r="30" stroke="#ff4d50" stroke-width="8" stroke-linecap="round" fill="none">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;180 50 50;720 50 50" keyTimes="0;0.5;1"></animateTransform>
                                <animate attributeName="stroke-dasharray" repeatCount="indefinite" dur="1s" values="18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882" keyTimes="0;0.5;1"></animate>
                                </circle>
                            </svg>
                        </div>
                        <div slot="no-results"></div>
                    </infinite-loading>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        lang: String,
        website_id: String,
        keyword: String,
        type: String,
        bgimg: String,
        website_review: String,
        route_search: String
    },

    data() {
        return {
            isLoading: true,
            page: 1,
            categories: [],
            products: [],
            products_total: 0,
            selected: {
                category: [],
                price: [],
                sortby: 'latest',
            },
            infiniteId: +new Date(),
            cdn_url: process.env.MIX_CDN_URL
        }
    },

    // mounted() {
    //     this.loadProducts();
    // },
    
    methods: {
        loadProducts($state)  {
            axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/search', {
                params: {
                    keyword: this.keyword,
                    page: this.page,
                    type: this.type,
                    category: this.selected.category,
                    price: this.selected.price,
                    sortby: this.selected.sortby
                },
            }).then(({ data }) => {
                this.products_total = data.products.total;
                this.categories = data.categories;
                    this.isLoading = false;
                if (data.products.data.length) {
                    this.page += 1;
                    this.products.push(...data.products.data);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        },

        filterProducts() {
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;

            //Scroll to top
            $('html, body').animate({
                scrollTop: $("#filterResults").offset().top
            });
        },

        loadCategories()  {
            axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/search')
                .then(response => {
                    this.categories = response.data.categories;
                    this.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        resetFilter() {
            this.isLoading = true;
            this.selected.category = [];
            this.selected.type = this.type;
        }
    }
}
</script>